import type { MutationProject } from '@common/api/graphql/createProjectGql';
import type { ProjectJson } from '@console/reducers/selectedProjectDraft';

export const getAdvertisingPeriod = (
  advertisingPeriod: ProjectJson['advertisingPeriod']
): MutationProject['advertisingPeriod'] => ({
  beginAt: advertisingPeriod.startDateOfAd || '',
  endAt: advertisingPeriod.endDateOfAd || ''
});
